import React from 'react';

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-[#3949ab] flex-col">
      <div className="flex space-x-4 mb-4">
        <div className="w-6 h-6 bg-white rounded-full animate-bounceAccent"></div>
        <div className="w-6 h-6 bg-white rounded-full animate-bounceAccent delay-200"></div>
        <div className="w-6 h-6 bg-white rounded-full animate-bounceAccent delay-400"></div>
      </div>
      <div className="text-white text-2xl font-semibold">
        ML-Factory
      </div>
      <style>
        {`
          @keyframes bounceAccent {
            0% {
              transform: translateY(0);
            }
            30% {
              transform: translateY(-15px);
            }
            50% {
              transform: translateY(0);
            }
            70% {
              transform: translateY(-15px);
            }
            100% {
              transform: translateY(0);
            }
          }

          .animate-bounceAccent {
            animation: bounceAccent 1s ease-in-out infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
